import { useAppTranslation } from "@/utils";
import { sdkFetch } from "@payping/api";
import { Badge, useMessagedAsync } from "@payping/web-components";
import { ComponentProps } from "react";

enum IpgHelperWithdrawStatusEnum {
  Pending = 0,
  Sended = 1,
  Succeed = 2,
  Returned = 3,
  Failed = 4,
}
export const useWithdrawStatus = () => {
  const { t } = useAppTranslation();

  const statusText = (
    status?: IpgHelperWithdrawStatusEnum,
  ): { text: string; color: ComponentProps<typeof Badge>["status"] } => {
    if (status === IpgHelperWithdrawStatusEnum.Pending || status === IpgHelperWithdrawStatusEnum.Sended) {
      return { text: t("withdraw.status.pending"), color: "default" };
    }
    if (status === IpgHelperWithdrawStatusEnum.Succeed) {
      return { text: t("withdraw.status.success"), color: "success" };
    }

    if (status === IpgHelperWithdrawStatusEnum.Returned) {
      return { text: t("withdraw.status.sendToBank"), color: "error" };
    }
    if (status === IpgHelperWithdrawStatusEnum.Failed) {
      return { text: t("withdraw.status.failed"), color: "error" };
    }
    return { text: t("withdraw.status.unknown"), color: "default" };
  };
  return { statusText };
};

const getLastWithdrawByStatus = async (
  status: IpgHelperWithdrawStatusEnum = IpgHelperWithdrawStatusEnum.Sended,
): Promise<
  | {
      amount?: number;
      reqDate?: string;
      repayDate?: string;
      status?: IpgHelperWithdrawStatusEnum;
      tag?: string;
      code?: string;
    }
  | undefined
> => {
  try {
    const res = await sdkFetch(`/v1/report/last-withdraw-by-status?status=${status}`);
    const json = res.json();
    return json;
  } catch (e) {
    throw e;
  }
};

export const useGetLastWithdrawByStatus = (status?: IpgHelperWithdrawStatusEnum) => {
  const { value, loading, error } = useMessagedAsync(() => getLastWithdrawByStatus(status), [getLastWithdrawByStatus], {
    error: false,
  });
  return { value, loading, error };
};

const getPendingWithdrawAmount = async (): Promise<number | undefined> => {
  try {
    const res = await sdkFetch(`/v1/report/pending-withdraw-amount`);
    const json = res.json();
    return json;
  } catch (e) {
    throw e;
  }
};

export const useGetPendingWithdrawAmount = () => {
  const { value, loading, error } = useMessagedAsync(getPendingWithdrawAmount, [getPendingWithdrawAmount], {
    error: false,
  });
  return { value, loading, error };
};
